import { Plus } from 'lucide-react';

import { PageHeader } from '@/shared/components/page-header';
import { Button } from '@/shared/components/shadcn/button';

type Props = {
  listCount: number;
  listLimit: number;
  onClickNewList: () => void;
  showNewBoardButton?: boolean;
};

export function BoardsHeader({
  listCount,
  listLimit,
  onClickNewList,
  showNewBoardButton = true,
}: Props) {
  return (
    <PageHeader
      title="Boards"
      description="Collect, organize, and export posts and profiles for your campaigns."
      actions={
        <>
          <p className="text-foreground text-sm font-semibold">
            {listCount} / {listLimit} Boards
          </p>
          {showNewBoardButton && (
            <Button onClick={onClickNewList}>
              <Plus className="size-4" />
              New board
            </Button>
          )}
        </>
      }
    />
  );
}
